var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxPopup',{attrs:{"visible":_vm.showPop,"show-close-button":true,"show-title":true,"title":'Testing...',"height":"700px","width":"1000px"},on:{"hidden":_vm.onHidden}},[_vm._v(" jdePop ")])
}
var staticRenderFns = []

export { render, staticRenderFns }